import HelpCenterLink from '@/components/general/HelpCenterLink'

const LINKS = {
  _default: 'https://support.shipbob.com',
  allNotifications: {
    notification: 'https://support.shipbob.com/en/articles/3952898-notifications-panel'
  },
  contactSupport: 'https://support.shipbob.com/en/articles/3944348-how-do-i-get-in-touch-with-shipbob-s-merchant-care-team',
  createOrder: {
    disclaimer: 'https://support.shipbob.com/en/articles/3972669-additional-services-pricing'
  },
  createReturns: 'https://support.shipbob.com/en/articles/3956238-returns-shipbob',
  createWro: {
    sendInventoryToFC: 'https://support.shipbob.com/en/articles/3955173-send-inventory-to-shipbob-wro',
    sendInventoryToHub: 'https://support.shipbob.com/s/article?articleName=New-Process-for-WRO-Creation-and-Receiving-for-Designated-Sites',
    freightAppointment: 'https://support.shipbob.com/en/articles/3948678-schedule-an-appointment',
    freightPartner: 'https://shipbob.freightos.com',
    lotItems: 'https://support.shipbob.com/en/articles/3955196-lot-items',
    dangerousGoods: 'https://support.shipbob.com/en/articles/3955192-manage-dangerous-goods-hazmat-items',
    nonIppSendDirectFees: 'https://support.shipbob.com/s/article/Custom-Routing-for-Receiving-Orders',
    hazmatGuidelines: 'https://support.shipbob.com/s/article/Manage-Dangerous-Goods-HAZMAT-Items'
  },
  dashboard: {
    urlPackaging: 'https://support.shipbob.com/en/articles/3955207-standard-packaging',
    urlKitting: 'https://support.shipbob.com/en/articles/3955200-kitting-and-de-kitting',
    urlB2bFulfillment: 'https://support.shipbob.com/en/articles/3960994-create-a-b2b-wholesale-order',
    urlCustomBoxPreference: 'https://support.shipbob.com/en/articles/3955207-standard-packaging',
    reorderPoint: 'https://support.shipbob.com/en/articles/3961069-reorder-point',
    totalFulfillmentCost: 'https://support.shipbob.com/en/articles/3971345-shipping-cost-table',
    slaArticle: 'https://support.shipbob.com/s/article/ShipBob-s-turnaround-times-policies-and-SLAs'
  },
  editWro: {
    changeProductsConfig: 'https://support.shipbob.com/en/articles/5473641-edit-warehouse-receiving-orders'
  },
  inventory: {
    lotNumber: 'https://support.shipbob.com/s/article/Lot-Items',
    bundleItems: 'https://support.shipbob.com/en/articles/3967384-bundle-items'
  },
  kyc: 'https://support.shipbob.com/s/article/Business-Information-Verification',
  locations: 'http://support.shipbob.com/en/articles/4477637-locations-page',
  orderDetails: {
    chargeBasedOnLink: 'https://support.shipbob.com/en/articles/2492665-dimensional-weight',
    destinationZones: 'https://support.shipbob.com/en/articles/3971349-shipping-zones',
    shippingOption: 'https://support.shipbob.com/en/articles/3968109-ship-option-mapping',
    bulkUpdate: 'https://support.shipbob.com/en/articles/3983304-bulk-update-for-product-details',
    shipOptionLearnMore: 'https://support.shipbob.com/en/articles/3944208-carriers-transit-time-and-shipping-options',
    addInsurance: 'https://support.shipbob.com/en/articles/3947712-add-insurance-to-shipments',
    twoDayExpress: 'https://support.shipbob.com/en/articles/5159265-shipbob-2-day-express'
  },
  orders: {
    status: {
      onHold: 'https://support.shipbob.com/en/articles/3967513-orders-in-on-hold-status'
    },
    sla: 'http://support.shipbob.com/en/articles/4100884-sla-badges'
  },
  packageSelection: {
    algo: 'https://support.shipbob.com/en/articles/3967380-box-selection-process'
  },
  payment: {
    failed: 'https://support.shipbob.com/en/articles/3967513-orders-in-on-hold-status'
  },
  pricing: {
    pricingPlan: 'https://support.shipbob.com/en/articles/3972669-additional-services-pricing',
    dimensionalWeight: 'https://support.shipbob.com/en/articles/2492665-dimensional-weight',
    customPackaging: 'https://support.shipbob.com/en/articles/3955207-standard-packaging',
    fulfillmentCost: 'https://support.shipbob.com/en/articles/3952384-your-pricing',
    pickAndPack: 'https://support.shipbob.com/en/articles/3948827-standard-b2c-pricing',
    standardPackaging: 'https://support.shipbob.com/en/articles/3955207-standard-packaging',
    shipping: 'https://support.shipbob.com/en/articles/3971345-shipping-cost-table',
    storage: 'https://support.shipbob.com/en/articles/3948827-standard-b2c-pricing',
    receiving: 'https://support.shipbob.com/en/articles/3948827-standard-b2c-pricing',
    additionalServices: 'https://support.shipbob.com/en/articles/3972669-additional-services-pricing',
    billableWeightEstimator: 'https://support.shipbob.com/en/articles/5367976-billable-weight-estimator'
  },
  productDetails: {
    bundling: 'https://support.shipbob.com/s/article/Bundle-Items',
    digitalProducts: 'https://support.shipbob.com/s/article/Digital-Items',
    lotProduct: 'https://support.shipbob.com/s/article/Lot-Items',
    dangerousGood: 'https://support.shipbob.com/s/article/Manage-Dangerous-Goods-HAZMAT-Items',
    prop65: 'https://support.shipbob.com/s/article/Prop-65',
    packageTypes: 'https://support.shipbob.com/s/article/Standard-Packaging',
    newProductDetailsPage: 'https://support.shipbob.com/s/article/Product-Details-Page',
    tariffCodeStandard: 'https://support.shipbob.com/s/article/Customs-Information',
    hsCodeLookUp: 'https://hts.usitc.gov/'
  },
  products: {
    addProducts: 'https://support.shipbob.com/s/article/Add-Products',
    casePack: 'https://support.shipbob.com/s/article/Case-Packed-Items',
    kitting: 'https://support.shipbob.com/s/article/Kitting',
    returnPreferences: 'https://support.shipbob.com/s/article/Returns-Return-To-Sender-Preferences'
  },
  returnsPricing: 'https://uiassets-afd.shipbob.com/legacyuiassets/webassets/ReturnsPricing.pdf',
  shippingMethod: {
    disclaimer: 'https://support.shipbob.com/en/articles/3944264-freight-faqs'
  },
  sla: 'https://support.shipbob.com/en/articles/3983367-shipbob-s-turnaround-times-policies-and-slas',
  transferPlans: {
    autoDistributedInventory: 'https://support.shipbob.com/s/article?articleName=ShipBob-s-Inventory-Placement-Program'
  },
  workOrders: {
    home: 'https://support.shipbob.com/en/articles/3955051-work-orders',
    disposal: 'https://support.shipbob.com/en/articles/3947742-donate-dispose-inventory',
    kitting: 'https://support.shipbob.com/s/article?articleName=Kitting'
  }
}

function HelpCenter () {
  const links = LINKS
  const keyOrDefault = (foundKey) => {
    if (typeof foundKey === 'string') return foundKey
    return links._default
  }
  // this.setup = (obj) => {
  //   links = Object.assign({}, links, obj)
  // }
  this.link = (key) => {
    let parsedKey = key
    if (parsedKey && parsedKey.indexOf('/') > 0) parsedKey = parsedKey.split('/')
    else if (parsedKey && parsedKey.indexOf('.') > 0) parsedKey = parsedKey.split('.')
    if (Array.isArray(parsedKey)) {
      let foundKey = links
      for (const k of parsedKey) {
        foundKey = foundKey[k]
        if (foundKey === undefined) break
      }
      return keyOrDefault(foundKey)
    }
    return keyOrDefault(links[parsedKey])
  }
}

export default {
  install (Vue, options) {
    Vue.prototype.$sbHelpCenter = new HelpCenter()
    Vue.component(HelpCenterLink.name, HelpCenterLink)
  }
}
